var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 269.925781 143.867188 C 268.390625 114.234375 256.121094 86.59375 234.984375 65.457031 C 212.34375 42.816406 182.238281 30.34375 150.21875 30.34375 C 118.199219 30.34375 88.097656 42.816406 65.457031 65.457031 C 52.90625 78.011719 43.488281 92.855469 37.582031 109.050781 L 72.367188 73.585938 L 82.007813 108.207031 C 96.140625 85.347656 121.429688 70.082031 150.21875 70.082031 C 188.570313 70.082031 220.710938 97.164063 228.53125 133.210938 L 211.824219 128.90625 L 233.089844 205.25 L 288.582031 148.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 227.640625 226.410156 L 217.996094 191.789063 C 203.871094 214.652344 178.578125 229.917969 149.78125 229.917969 C 111.429688 229.917969 79.289063 202.835938 71.46875 166.789063 L 88.171875 171.09375 L 66.914063 94.75 L 11.417969 151.324219 L 30.074219 156.128906 C 31.609375 185.765625 43.875 213.40625 65.015625 234.542969 C 87.65625 257.1875 117.761719 269.65625 149.78125 269.65625 C 181.800781 269.65625 211.902344 257.1875 234.542969 234.542969 C 247.101563 221.984375 256.527344 207.140625 262.429688 190.941406 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/Shuffle.a89d75a6f135551fbb24f7aa9bf51cdc.svg";
export { ForwardRef as ReactComponent };